import type { Agency } from '@/modules/agencies/types/agency'
import { AgencyStatusPill } from '@/modules/agencies/components/AgencyStatusPill'
import { formatAgencyDate } from '@/modules/agencies/utils/formatAgencyDate'
import { getAgencyStatusTone } from '@/modules/agencies/utils/agencyStatusTone'

export type AgencyTableProps = {
  agencies: Agency[]
  onSelectAgency: (agencyId: string) => void
}

export function AgencyTable({ agencies, onSelectAgency }: AgencyTableProps) {
  return (
    <div className="overflow-x-auto border-2 border-ink bg-surface">
      <table className="min-w-full border-collapse text-left text-sm">
        <thead className="border-b-2 border-ink bg-paper">
          <tr>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Name
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Slug
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Status
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Created
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Updated
            </th>
          </tr>
        </thead>
        <tbody>
          {agencies.map((agency) => (
            <tr key={agency.id} className="border-b border-line last:border-b-0 hover:bg-paper">
              <td className="px-4 py-3 font-semibold text-ink">
                <button
                  type="button"
                  onClick={() => onSelectAgency(agency.id)}
                  className="text-left underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
                >
                  {agency.name}
                </button>
              </td>
              <td className="px-4 py-3 font-mono text-[0.82rem] text-muted">
                {agency.slug}
              </td>
              <td className="px-4 py-3">
                <AgencyStatusPill
                  status={agency.status}
                  tone={getAgencyStatusTone(agency.status)}
                />
              </td>
              <td className="px-4 py-3 text-muted">
                {formatAgencyDate(agency.createdAt)}
              </td>
              <td className="px-4 py-3 text-muted">
                {formatAgencyDate(agency.updatedAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
